<template>
  <ImportRegistryComponent />
</template>

<script>
import ImportRegistryComponent from '../../../../components/mail/create/ImportRegistryComponent'
import {LAYOUT_TITLE_CHANGED} from "../../../../store/modules/layout/actions";
import {MAIL_CREATED} from "../../../../events/mail";

export default {
  name: "MailImportRegistryFormPage",
  components: {
    ImportRegistryComponent
  },
  methods: {
    onMailCreated(mail) {
      this.$router.push({name: 'mail-view', params: {id: mail.id}})
    }
  },
  created() {
    this.$store.dispatch(LAYOUT_TITLE_CHANGED, this.$t('mailImportRegistryFormPage.pageTitle'))

    this.$bus.$on(MAIL_CREATED, this.onMailCreated)
  },
  beforeDestroy() {
    this.$bus.$off(MAIL_CREATED, this.onMailCreated)
  }
}
</script>

<style scoped>

</style>